"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionAggregates = exports.SurveyDemographics = exports.SurveyWeights = void 0;
var SurveyWeights;
(function (SurveyWeights) {
    SurveyWeights["Updated"] = "SURVEY_WEIGHTS_UPDATED";
    SurveyWeights["Ingested"] = "SURVEY_WEIGHTS_INGESTED";
})(SurveyWeights || (exports.SurveyWeights = SurveyWeights = {}));
var SurveyDemographics;
(function (SurveyDemographics) {
    SurveyDemographics["Updated"] = "SURVEY_DEMOGRAPHICS_UPDATED";
})(SurveyDemographics || (exports.SurveyDemographics = SurveyDemographics = {}));
var QuestionAggregates;
(function (QuestionAggregates) {
    QuestionAggregates["Updated"] = "BENCHMARK_SURVEY_QUESTION_AGGREGATES_UPDATED";
})(QuestionAggregates || (exports.QuestionAggregates = QuestionAggregates = {}));
